import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { NotificationExtended, NotificationExtendedListResponse, NotificationQueryParams } from '@frontend/notification/types';

export class NotificationExtendedClient extends APIClient {
    public static readonly endpoint = '/notification-api/ext/v1';

    public static async fetchNotificationsExtended(queryParams?: ApiQueryParams<NotificationQueryParams>): Promise<NotificationExtendedListResponse> {
        return await this.apiPaginated<NotificationExtendedListResponse, NotificationQueryParams>(`${this.endpoint}/notifications`, queryParams);
    }

    public static async fetchNotificationExtended(account_id: string, notification_id: string): Promise<NotificationExtended> {
        const response = await this.fetch(`${this.endpoint}/accounts/${account_id}/notifications/${notification_id}`);
        return await this.handleResponse<NotificationExtended>(response);
    }
}
